import { StackLayout } from '@leagueplatform/genesis-core';
import { MasonryEngine } from '@leagueplatform/masonry-engine';
import { getMasonryDriver } from '@leagueplatform/masonry';

const MasonryDriver = getMasonryDriver({
  rootNodeId: 'premium-payment-history$root',
});

export const PremiumPaymentHistoryMasonrySection = () => (
  <StackLayout
    orientation="vertical"
    css={{
      marginBottom: '$three',
    }}
  >
    <MasonryEngine driver={MasonryDriver} />
  </StackLayout>
);
